import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

// import VueGapi from 'vue-gapi'
import firebase from 'firebase'

import BootstrapVue from 'bootstrap-vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import globals from './globals'
import Popper from 'popper.js'
import * as momentVue from 'vue-moment'
import * as moment from 'moment'
import Notifications from 'vue-notification'
require('moment/locale/pl')

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(ElementUI)

Vue.use(Notifications)
Vue.use(momentVue, {
  moment
})

// Vue.use(VueGapi, {
//   apiKey: 'AIzaSyCtp5nm0ft4Pow7xwEB4i1Vtp50R-Yri7Q'
// })

// Global RTL flag
Vue.mixin({
  data: globals
})

const { firebaseAuth } = globals()

firebase.initializeApp(firebaseAuth).auth().onAuthStateChanged((user) => {
  /* eslint-disable no-new */
  if (user && user.uid) {
    store.dispatch('login', user.uid).finally(() => {
      const app = new Vue({ router, store, render: h => h(App) }).$mount('#app')
    })
  } else {
    const app = new Vue({ router, store, render: h => h(App) }).$mount('#app')
    store.dispatch('logout')
  }
})
